class AgendamentoAlteracaoActionTypes {
  constructor() {
    this.SET_AGENDAMENTOS = 'SET_AGENDAMENTOS';
    this.ADD_AGENDAMENTO = 'ADD_AGENDAMENTO';
    this.REMOVE_AGENDAMENTO = 'REMOVE_AGENDAMENTO';
    this.CLEAR_AGENDAMENTOS = 'CLEAR_AGENDAMENTOS';
  }
}

export default new AgendamentoAlteracaoActionTypes();
